(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["berrys-luxury-footer"]) return;
  try {
    
if (!customElements.get('berrys-luxury-footer')) {
  customElements.define('berrys-luxury-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.footerController) return;
      this.footerController = new AbortController();
      const signal = this.footerController.signal;
      const groups = Array.from(this.querySelectorAll('.bf-group'));
      const mobile = window.matchMedia('(max-width: 900px)');
      const sync = () => groups.forEach(group => { group.open = !mobile.matches; });
      sync();
      mobile.addEventListener('change', sync, {signal});
      groups.forEach(group => group.querySelector('.bf-group-title').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      }, {signal}));
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        let current = event.target;
        while (current && current !== this) {
          if (current.tagName === 'DETAILS') current.open = true;
          current = current.parentElement;
        }
      }, {signal});
    }
    disconnectedCallback() {
      if (this.footerController) this.footerController.abort();
      this.footerController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["berrys-patek-product"]) return;
  try {
    

if (!customElements.get('berrys-patek-product')) {
  customElements.define('berrys-patek-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      this.querySelectorAll('[data-patek-enquiry]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !dialog.showModal) return;
          event.preventDefault();
          this.opener = link;
          const frame = dialog.querySelector('[data-patek-form]');
          if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
          dialog.showModal();
          dialog.scrollTop = 0;
        }, options);
      });
      dialog.querySelector('[data-patek-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); }, options);
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      window.addEventListener('message', event => {
        const frame = dialog.querySelector('[data-patek-form]');
        if (event.source !== frame.contentWindow || event.origin !== 'https://form.jotform.com') return;
        if (typeof event.data !== 'string') return;
        const parts = event.data.split(':');
        if (parts[0] !== 'setHeight') return;
        const height = Number(parts[1]);
        if (Number.isFinite(height) && height >= 300 && height <= 12000) frame.style.height = `${height}px`;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["br26-sale-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialiseSaleSelection(root) {
      if (root.dataset.enhanced) return;
      const tablist = root.querySelector('[data-brsale-tabs]');
      const tabs = Array.from(root.querySelectorAll('[data-brsale-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-brsale-panel]'));
      if (!tablist || !tabs.length || tabs.length !== panels.length) return;
      function selectTab(index, focus) {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) tabs[index].focus();
      }
      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        const panel = panels[index];
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => selectTab(index, false));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); selectTab(next, true);
        });
      });
      root.dataset.enhanced = 'true'; tablist.hidden = false; selectTab(0, false);
      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-brsale-panel]');
        const index = panels.indexOf(panel);
        if (index >= 0) selectTab(index, false);
      });
    }
    function initialiseWithin(scope) {
      if (scope.matches && scope.matches('[data-brsale-selection]')) initialiseSaleSelection(scope);
      scope.querySelectorAll('[data-brsale-selection]').forEach(initialiseSaleSelection);
    }
    initialiseWithin(document);
    document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('#cart-drawer [data-bdrawer-step]');
  if (!button || button.disabled) return;
  const input = button.closest('.bdrawer-quantity').querySelector('input');
  const next = Number(input.value) + Number(button.dataset.bdrawerStep) * (Number(input.step) || 1);
  const maximum = input.max === '' ? Infinity : Number(input.max);
  if (!Number.isFinite(next) || next < Number(input.min) || next > maximum) return;
  input.value = next;
  input.dispatchEvent(new Event('change', {bubbles:true}));
});
document.addEventListener('change', event => {
  const input = event.target.closest('#cart-drawer input[data-bdrawer-quantity]');
  if (!input || input.checkValidity()) return;
  event.stopImmediatePropagation();
  input.reportValidity();
  input.value = input.dataset.bdrawerQuantity;
}, true);

  } catch(e) { console.error(e); }
})();
})();
